import type { WidgetMessages } from './types.ts';

export const fr: WidgetMessages = {
  panelTitle: 'Envoyer un commentaire',
  panelClose: 'Fermer',
  fieldTitleLabel: 'Résumé bref',
  fieldTitlePlaceholder: 'Description courte',
  fieldSummaryLabel: 'Détails',
  fieldSummaryPlaceholder:
    'Étapes pour reproduire, ce que vous attendiez, ce qui s’est réellement passé…',
  fieldNameLabel: 'Votre nom',
  fieldEmailLabel: 'Votre adresse e-mail',
  fieldSaveContactLabel: 'Enregistrer votre nom et votre e-mail',
  fieldSaveContactUnavailable:
    'Votre navigateur bloque le stockage, cela ne peut donc pas être enregistré.',
  fieldNotifyOnFixLabel: 'M’avertir par e-mail quand ce sera corrigé',
  buttonSend: 'Envoyer le rapport',
  buttonSending: 'Envoi…',
  buttonWaitingForUploads: 'Attente des pièces jointes…',
  errorTitleRequired: 'Veuillez ajouter un résumé bref.',
  successHeading: 'Merci — votre rapport a bien été envoyé.',
  successCopy: (ref) => `Code de référence : ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? "Votre pièce jointe n'a pas pu être traitée et n'a pas été incluse dans le rapport."
        : `Les ${total} pièces jointes n'ont pas pu être traitées et n'ont pas été incluses dans le rapport.`
      : `${failed} pièce(s) jointe(s) sur ${total} n'ont pas pu être traitées et n'ont pas été incluses dans le rapport.`,
  successAnotherButton: 'Envoyer un autre rapport',
  poweredBy: 'Propulsé par OnCatch',

  recordingConsentTitle: 'Enregistrer votre écran',
  recordingConsentLead: (ws) =>
    `Vous êtes sur le point de partager votre écran avec l’équipe support de ${ws} pour démontrer un bug.`,
  recordingConsentBulletAdminsOnly:
    'L’enregistrement est envoyé uniquement aux administrateurs de votre espace de travail.',
  recordingConsentBulletMicAudio:
    'L’audio du microphone est capturé si votre navigateur le permet ; vous verrez une demande d’accès.',
  recordingConsentBulletMaxLength:
    'La durée maximale est de 5 minutes — l’enregistrement s’arrête automatiquement à la limite.',
  recordingConsentBulletRetention: (d) =>
    `Conservé pendant ${d} jours, puis supprimé automatiquement.`,
  recordingConsentBulletDeletion:
    'Vous pouvez demander une suppression anticipée depuis les paramètres de votre compte.',
  recordingConsentCancelBtn: 'Annuler',
  recordingConsentAcceptBtn: 'J’accepte, démarrer l’enregistrement',
  recordingChoiceTitle: 'Choisissez un enregistrement',
  recordingChoiceLead:
    'Choisissez ce que vous souhaitez capturer. Vous vérifierez ce qui est partagé avant le début de l’enregistrement.',
  recordingChoiceScreen: 'Enregistrement d’écran',
  recordingChoiceScreenDetail:
    'Enregistrez votre écran et, si vous le souhaitez, le son du microphone.',
  recordingChoiceCamera: 'Enregistrement d’écran avec caméra',
  recordingChoiceCameraDetail: 'Enregistrez votre écran avec une incrustation de caméra.',
  recordingChoiceAudio: 'Enregistrement audio',
  recordingChoiceAudioDetail: 'Enregistrez uniquement le son de votre microphone.',
  recordingChoiceUnavailable: 'Non disponible dans ce navigateur',
  recordingAudioConsentTitle: 'Enregistrer l’audio',
  recordingAudioConsentLead: (ws) =>
    `Le son de votre microphone sera partagé avec l’équipe d’assistance de ${ws} pour aider à expliquer ce problème.`,
  recordingAudioConsentTip:
    'Votre navigateur demandera ensuite l’accès au microphone. Choisissez le microphone à utiliser, puis autorisez l’accès.',

  recordingTimerIdle: 'Enregistrement 0:00',
  recordingTimer: (m, s) => `Enregistrement ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Arrêter',
  recordingStartedAnnouncement: 'Enregistrement démarré',
  recordingProgressAnnouncement: (sec) => `Enregistrement ${sec} secondes`,

  captureRegionHelp:
    'Cliquez et faites glisser pour sélectionner une zone · Appuyez sur Échap pour annuler',
  captureLabelCapturing: 'Capture en cours…',
  captureLabelPreparing: 'Préparation…',
  captureRegionCapturing: 'Capture de la zone…',

  safariUnsupportedTitle: 'L’enregistrement d’écran n’est pas pris en charge sur ce navigateur',
  safariUnsupportedBody:
    'L’enregistrement d’écran nécessite Chrome, Edge ou Firefox sur ordinateur. Vous pouvez toujours joindre des captures d’écran et envoyer votre rapport.',

  attachmentsLabel: 'Pièces jointes',
  captureWholePageBtn: 'Page entière',
  captureSelectRegionBtn: 'Sélectionner une zone',
  captureSelectElementBtn: 'Sélectionner un élément',
  captureRecordBtn: 'Enregistrer',
  cameraDeniedFallback: 'Accès à la caméra refusé — enregistrement de l’écran uniquement.',
  recordingConsentBulletCamera:
    'Votre caméra apparaîtra dans le coin de l’enregistrement. Refusez la demande de caméra pour enregistrer uniquement l’écran.',
  recordingConsentIncludeCameraLabel: 'Inclure la caméra',
  recordingUnsupportedInline:
    'L’enregistrement d’écran n’est pas pris en charge dans ce navigateur. Les captures fonctionnent toujours.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Téléverser un fichier',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Limite de pièces jointes atteinte — supprimez-en une pour téléverser.',
  uploadErrorUnsupportedType:
    'Seuls les fichiers PNG, JPEG, WebP, PDF ou DOCX peuvent être téléversés.',
  uploadErrorFileTooLarge: 'Fichier trop volumineux (max. 50 Mo).',
  uploadErrorGeneric: 'Échec du téléversement. Veuillez réessayer.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 fichier ignoré — limite de pièces jointes atteinte.'
      : `${skipped} fichiers ignorés — limite de pièces jointes atteinte.`,

  storageFullNotice: 'Pièces jointes indisponibles',
  storageFullDetailedNotice:
    'Pièces jointes indisponibles — stockage de l’espace de travail saturé',

  challengeIntro: 'Vérification rapide pour confirmer que vous êtes humain.',
  challengeFailed: 'La vérification a échoué. Veuillez réessayer.',

  annotateTitle: 'Annoter la capture',
  toolArrow: 'Flèche',
  toolBox: 'Cadre',
  toolPen: 'Dessiner',
  toolText: 'Texte',
  colorRed: 'Rouge',
  colorYellow: 'Jaune',
  colorGreen: 'Vert',
  colorBlack: 'Noir',
  buttonUndo: 'Annuler',
  buttonClear: 'Effacer',
  buttonSkip: 'Passer',
  buttonSave: 'Enregistrer',
  textInputPlaceholder: 'Tapez l’étiquette, appuyez sur Entrée',
  saveError: 'Impossible d’enregistrer. Capture brute envoyée.',
  activeIndicator: 'actif',
};
